import { computed } from 'vue'

export function useBlogPagination(currentPage, totalPages, { delta = 2 } = {}) {
  const visiblePages = computed(() => {
    const current = currentPage.value
    const total = totalPages.value
    const pages = []

    let start = Math.max(1, current - delta)
    let end = Math.min(total, current + delta)

    if (end - start < 2 * delta) {
      start = Math.max(1, end - 2 * delta)
    }

    for (let i = start; i <= end; i++) {
      pages.push(i)
    }

    return pages
  })

  return { visiblePages }
}
